import { render, staticRenderFns } from "./login-tablet.vue?vue&type=template&id=2d7b10aa&"
import script from "./login-tablet.vue?vue&type=script&lang=js&"
export * from "./login-tablet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports